import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { WidgetResourceUrlPipe } from '../pipes';
import { injectWidgetConfigProp } from '@panaya/ai-chat/utils';
import { AiChatUiEventsService } from '../ai-chat-ui-events.service';

@Component({
    selector: 'p-ai-chat-trigger-button',
    standalone: true,
    imports: [WidgetResourceUrlPipe, NgClass],
    templateUrl: './ai-chat-trigger-button.component.html',
    styleUrls: ['./ai-chat-trigger-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiChatTriggerButtonComponent {
    @Input() public action!: 'init' | 'close';
    @Output() public actionChanged = new EventEmitter<'init' | 'close'>();

    protected readonly aiChatUiEventsService = inject(AiChatUiEventsService);
    protected readonly triggerImageURL = (() => {
        const value = injectWidgetConfigProp('triggerImageURL');
        return typeof value === 'function' ? value() : value;
    })();
    protected readonly triggerImageHoveredURL = injectWidgetConfigProp('triggerImageHoveredURL');
    protected readonly triggerImageCustomClass = injectWidgetConfigProp('triggerImageCustomClass');
    protected isHovered = false;

    protected changeAction(): void {
        const newAction = this.action == 'init' ? 'close' : 'init';
        this.actionChanged.emit(newAction);

        if (newAction === 'init') {
            this.aiChatUiEventsService.triggerLaunch();
        }
    }
}
